import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '@shared/angular-material';

import { BeeDirectivesModule } from '@bee-components/common/bee-directives/bee-directives.module';

import { BeeFormItemComponent } from './bee-form-item.component';

@NgModule({
  declarations: [
    BeeFormItemComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    BeeDirectivesModule
  ],
  exports: [
    BeeFormItemComponent
  ]
})
export class BeeFormItemModule { }
